import { AbstractValidator } from './abstract-validator';

const getCheckedInputs = input => input.form.querySelectorAll(`[name="${input.getAttribute('name')}"]:checked`);

export class RequiredValidator extends AbstractValidator {
    static getIdentifier() {
        return 'required';
    }
    static isApplicable(input) {
        return super.isApplicable(input) && input.hasAttribute('required');
    }
    static validate(input) {
        return (onError, onSuccess) => {
            if (input.tagName === 'TEXTAREA' && !input.value) {
                onError();
                return;
            }
            if (input.tagName === 'INPUT') {
                switch (input.type) {
                    case 'text':
                    case 'number':
                    case 'email':
                    case 'tel':
                        if (!input.value) {
                            onError();
                            return;
                        }
                        break;
                    case 'checkbox':
                        if (input.form.querySelectorAll(`[name="${input.getAttribute('name')}"]`).length === 1 && !input.checked) {
                            onError();
                            return;
                        }
                        if (getCheckedInputs(input).length === 0) {
                            onError();
                            return;
                        }
                        break;
                    case 'radio': {
                        if (getCheckedInputs(input).length === 0) {
                            onError();
                            return;
                        }
                        break;
                    }
                }
            }
            onSuccess();
        };
    }
}
